import api from "./index";

export default {
  getRegions() {
    return api().post("/base-js/search", {
      type: "directory",
      typeObj: "region"
    }, { withCredentials: true })
  },
  getAllDSUsers() {
    return api().post("/base-js/search", {
      type: "directory",
      typeObj: "userDC"
    }, { withCredentials: true })
  },
}